import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import { useContext } from 'preact/compat';
import Styles from './styles';
function VoucherMessage({ showQuickPay, options, }) {
    const { voucherMessage, } = useContext(options);
    if (!showQuickPay) {
        return null;
    }
    return (_jsxs(Styles.Element, { children: [_jsx(Styles.Icon, { children: _jsx("use", { xlinkHref: "#icon--gift" }) }), _jsx(Styles.Message, { children: voucherMessage })] }));
}
export default VoucherMessage;
